<div *ngIf="data?.twoButton">
    <div class="text-center mb-5">
        <p class="label-val2-new-line">{{data?.labelVal}}</p>
    </div>
    <div class="row">
        <div class="col-md-6 text-md-right">
            <div class="button-group-secondary">
                <button class="secondary-button"
                    (click)='onClickToSelectSecondary(data?.secondaryButVal)'>{{data?.secondaryButVal}}</button>
            </div>
        </div>
        <div class="col-md-6 text-md-left">
            <div class="button-group-secondary">
                <button class="primary-button"
                    (click)='onClickToSelectPrimary(data?.primaryButVal)'>{{data?.primaryButVal}}</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!data?.title && data?.oneButton">
    <div class="d-flex justify-content-center px-5">
        <div *ngIf="data?.labelVal2 || data?.labelVal1">
            <img class="exclamation-size" *ngIf="data?.showMaintenanceIcon"
        src="./assets/images/New_Exclamation_mark.svg" alt="action icon" />
        </div>
        <div class="ml-2" [ngClass]="{ 'maintenance-bottom': data?.showMaintenanceIcon}">
            <p *ngIf="data?.labelVal1" class="label-val2-new-line"> {{data?.labelVal1}}</p>
            <p *ngIf="data?.labelVal2" class="label-val2-new-line"> {{data?.labelVal2}}</p>
        </div>
        <div *ngIf="data?.labelVal3 || data?.labelVal4">
            <img class="exclamation-size" *ngIf="data?.showMaintenanceIcon"
        src="./assets/images/New_Exclamation_mark.svg" alt="action icon" />
        </div>
        <div class="ml-2" [ngClass]="{ 'maintenance-bottom': data?.showMaintenanceIcon}">
            <p *ngIf="data?.labelVal3" class="label-val3-new-line"> {{data?.labelVal3}}</p>
            <p *ngIf="data?.labelVal4" class="label-val4-new-line"> {{data?.labelVal4}}</p>
        </div>
    </div>
    <div class="text-center button-group-secondary">
        <button class="primary-button"
            (click)='onClickToSelectPrimary(data?.primaryButVal)'>{{data?.primaryButVal}}</button>
    </div>
</div>

<div *ngIf="data?.title && data?.oneButton">
    <p>{{data?.labelVal1}}</p>
    <p class='disk' [innerHTML]='data?.labelVal2'>{{data?.labelVal2}}</p>
    <div class="text-center button-group-secondary">
        <button class="primary-button"
            (click)='onClickToSelectPrimary(data?.primaryButVal)'>{{data?.primaryButVal}}</button>
    </div>
</div>